import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionPlayerEffects } from './competition-player.effects'
import * as fromCompetitionPlayer from './competition-player.reducer'
import { CompetitionPlayerSerializer } from './competition-player.serializer'
import { CompetitionPlayerService } from './competition-player.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionPlayer.FEATURE_NAME,
      fromCompetitionPlayer.competitionPlayerReducer
    ),
    EffectsModule.forFeature([CompetitionPlayerEffects])
  ],
  providers: [
    CompetitionPlayerService,
    {
      provide: CompetitionPlayerSerializer,
      useClass: CompetitionPlayerSerializer
    }
  ],
  declarations: []
})
export class CompetitionPlayerModule {}
